import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { FiShoppingBag } from 'react-icons/fi';

export const CART_CONFIG = {
  cartSummaryCard: {
    submitOrderButton: {
      variant: 'accent' as ButtonProps['variant'],
    },
  },
  pageHeader: {
    cart: {
      icon: <FiShoppingBag className="h-5 w-5" />,
    },
  },
  cartItem: {
    description: {
      visible: true,
    },
  },
};
